/**
 * Nsection B3 Service
 * B.3.術語定義 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b3';

export interface DefinitionItem {
  term: string;
  definition: string;
}

export interface NsectionB3Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  definitions: DefinitionItem[] | null;
  nsection_b3_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB3Update {
  definitions?: DefinitionItem[];
}

const nsectionB3Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB3Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB3Update): Promise<NsectionB3Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
};

export default nsectionB3Service;
